 export default ([{
  title: "menuP2P",
  route: {
    name: "home"
  },
  icon: "P2p",
  children: [{
    title: "menuBuySell",
    route: "home",
    icon: "BuySell"
  }, {
    title: "menuMyAds",
    route: "my-ads",
    icon: "MyAds"
  }, {
    title: "menuOrder",
    route: "order",
    icon: "Order"
  }]
}, {
  title: "menuWallet",
  route: "wallet",
  icon: "Wallet"
}, {
  title: "menuAccount",
  route: {
    name: "home"
  },
  icon: "Account",
  children: [{
    title: "menuVerification",
    route: "verification",
    icon: "Verification"
  }, {
    title: "menuSecurity",
    route: "security",
    icon: "Security"
  }, {
    title: "menuPayment",
    route: "payment",
    icon: "Payment"
  }]
}]);

